/*
Akhila 04/25/2023 3075154998  Added usage and override functionality in transformation group
Akhila 04/25/2023 3075154998 rename the usage dialoge box
Akhila 04/26/2023 3075154998 removed repository name from table
Prakash 26/04/2023 3075154998 fixed button spacing issue and alignments issue

*/
import React, {useEffect, useState} from 'react';
import capitalize from '../../../../../../util/Capitalize';
import {useSelector, useDispatch} from 'react-redux';
import PageLoader from '../../../../../../components/PageLoader';
import {Button, TablePagination} from '@material-ui/core';
// import { postPrintUsage, resetPrintUsageData } from "../../../../redux/reducers/printUsage";
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import {ArrowBack} from '@material-ui/icons';
import {defaultRows} from '../../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../../constants/ReusableConstants';
// import { resetTriggerUsage } from "../../../../../../redux/reducers/EventTactics/EventTactics";
import {
  resetPreprocessorGroupUsage,
} from '../../../../../../redux/reducers/DataManagerRecord';
import {modulesText} from '../../../../../../util/Content';
function PreprocessoreGroupUsage({preprocessorUsage, handleUsageClose}) {
  const {isAddProcessorLoading, preProcessorUsageData} = useSelector(
    ({dataManagerRecord}) => dataManagerRecord,
  );
  console.log(preProcessorUsageData, 'preProcessorUsageData');
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      dispatch(resetPreprocessorGroupUsage());
    };
  }, []);

  const [rows, setRows] = useState(defaultRows);
  const {
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);

  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPreprocessorGroupUsage());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);

  const object = preProcessorUsageData?.placeResponse ? preProcessorUsageData?.placeResponse : {};

  const values = [];
  object &&
    Object.entries(object)?.forEach(([key, value]) => {
      value?.length > 0 &&
        value?.forEach((el, i) => {
          values.push({
            frameWork: key,
            codes: el?.code,
            description: el?.description ?? '',
          });
        });
    });
  const columns = [
    {
      title: modulesText,
      field: 'frameWork',
      render: (rowData) => {
        return rowData?.frameWork ? capitalize(rowData?.frameWork) : '--';
      },
    },
    {
      title: 'Name',
      field: 'codes',
      render: (rowData) => {
        return rowData?.codes ? rowData?.codes : '--';
      },
    },
    {
      title: 'Description',
      field: 'description',
      render: (rowData) => {
        return rowData?.description ? rowData?.description : '--';
      },
    },
    // {
    //   title: "Repository Fields",
    //   field: "repositoryFields",
    //   render: (rowData) => {
    //     return rowData?.repositoryFields ? rowData?.repositoryFields : "--";
    //   },
    // },
  ];
  return (
    <div className="new-standard-textfields col-12">
      <div className={` mb-0`}>
        <div className="button-table-spacing-mb justify-content-start">
          <Button
            variant="outlined"
            type="button"
            className={`search-btn mx-1`}
            onClick={() => {
              handleUsageClose();
            }}
          >
            <ArrowBack className="mr-2" />
            Go Back
          </Button>
        </div>
        <div className="custom-table custom-toolbar-icons global-field-table">
          <GuiTable
            title={`${preprocessorUsage?.processorGroupCode} - ${preprocessorUsage?.processorType} This Transformation Group has been used in the following places.`}
            columns={columns}
            data={values}
            textAlign="left"
            options={{
              paging: true,
              toolbar: true,
              search: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
              pageSize: rows,
              pageSizeOptions: tablePageRows,
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer d-flex justify-content-end ">
                  {/* <div className="mt-2">
                    <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn ${classes.buttonRoot}`}
                      color="primary"
                      disabled={triggerUsageData?.userMetrix === "No"}
                      onClick={(event) => {
                        dispatch(
                          postPrintUsage({
                            baseCategory: "",
                            code: triggerMaintenanceData?.code ? triggerMaintenanceData?.code : "",
                            description: triggerMaintenanceData?.description
                              ? triggerMaintenanceData?.description
                              : "",
                            displayName: "",
                            fileType: "",
                            recordFormatType: "",
                            returnType: "",
                            sourceType: "TRIGGER MAINTENANCE",
                            isDraft: "",
                            search: "",
                            frameworkUsageOrderBy: "",
                            frameworkUsageOrderDerection: "",
                            fieldListOrderBy: "",
                            fieldListOrderDerection: "",
                            category: "",
                            fieldName: "",
                            repositoryDescription: "",
                            repositoryName: "",
                            repositoryType: "",
                            createdBy: "",
                            createdDate: "",
                          })
                        );
                      }}
                    >
                      Download Configuration Usage
                    </Button>
                  </div> */}
                  <div style={{backgroundColor: 'white', border: '0px'}}>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
            }}
          />
        </div>
      </div>
      {isAddProcessorLoading && <PageLoader />}
      {/* {(errorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || printUsageErrorMsg} />
      )}
      {(successMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar successMsg={successMsg || printUsageSuccessMsg} />
      )} */}
    </div>
  );
}

export default PreprocessoreGroupUsage;
